/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberRefundSummary {
  amount?: number;
  boxId?: string;
  city?: string;
  dateCreated?: Date;
  dateRefunded?: Date;
  editionId?: number;
  firstName?: string;
  hasBeenApproved?: number;
  hasRefunded?: number;
  lastName?: string;
  lastSubscriberBillingStatus?: number;
  message?: string;
  neighborhood?: string;
  partialRefund?: number;
  paymentLogId?: number;
  personId?: number;
  postalCode?: string;
  removeEdition?: number;
  state?: string;
  street?: string;
  streetExtension?: string;
  streetNumber?: string;
  subscriberBillingId?: number;
  subscriberBillingStatus?: string;
  subscriberId?: number;
  theme?: string;
  username?: string;
}
